export const DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES = 30;
export const DATA_TRANSMISSION_ONLINE_THRESHOLD = 5;
